// =============================================================================
// SHARE STORIES BUTTON - Trigger button for Instagram Stories sharing
// =============================================================================

import { motion } from 'framer-motion';

interface ShareStoriesButtonProps {
    onClick: () => void;
    className?: string;
    variant?: 'primary' | 'secondary' | 'minimal';
    showLabel?: boolean;
}

export function ShareStoriesButton({
    onClick,
    className = '',
    variant = 'primary',
    showLabel = true,
}: ShareStoriesButtonProps) {
    const baseStyles = 'font-mono uppercase tracking-wider transition-all flex items-center justify-center gap-2';

    const variantStyles = {
        primary: 'px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white text-sm font-bold',
        secondary: 'px-4 py-2 border-2 border-purple-500/50 text-purple-400 hover:border-purple-400 hover:text-purple-300 text-xs',
        minimal: 'px-3 py-1.5 text-war-dim hover:text-purple-400 text-xs',
    };

    return (
        <motion.button
            onClick={onClick}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={`${baseStyles} ${variantStyles[variant]} ${className}`}
            aria-label="Поділитися в Instagram Stories"
        >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z" />
                <circle cx="12" cy="12" r="3.5" />
            </svg>
            {showLabel && (
                <span>{variant === 'minimal' ? 'Stories' : 'INSTAGRAM STORIES'}</span>
            )}
        </motion.button>
    );
}
